import React from "react";
import { StickyTopRowStack } from "../../../../components/commonComponents/StyledComponents/styled";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateStateData } from "../../../../Store/actions";
import MultiSelect from "../../../../components/commonComponents/Selectors/MultiSelect";
import { findStoreIds, independentStoreListOptions } from "../../../../api_calls/utils";

const StatusMonitoringFilter = ({ reduxKeywordToSaveValue }) => {
  const currentStateData = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  let independentStoreList = independentStoreListOptions(); //multiple values
  const statusValues = ["Online",  "Offline", "Closed"]; // "Reconnecting" (removed on 8 oct 2025 on request)
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const [changesMade, setChangesMade] = React.useState(false);
  const [statusSelection, setStatusSelection] = React.useState([]);
  const [selectedStatusName, setSelectedStatusName] = React.useState([]);

  const handleStatusSelection = (e) => {
    setChangesMade(true);
    setStatusSelection((preState) => {
      if (preState.includes("(All)") && !e.target.value.includes("(All)")) {
        return [];
      } else if (
        preState.includes("(All)") &&
        e.target.value.includes("(All)") &&
        e.target.value.length !== statusValues.length
      ) {
        const selectedOptions = e.target.value.filter((option) => option !== "(All)");
        return selectedOptions;
      } else if (!preState.includes("(All)") && e.target.value.length === statusValues.length - 1) {
        // Replace selection with "(All)"
        return statusValues;
      } else {
        if (e.target.value.includes("(All)")) {
          return statusValues;
        } else {
          return e.target.value.length === 0 ? [] : e.target.value;
        }
      }
    });
  };

  React.useEffect(() => {
    setStatusSelection(statusValues);
    setSelectedStatusName(
      statusValues.map((statusName) => {
        return { value: statusName, label: statusName };
      })
    );
    // set values in redux on page load.
    dispatchAction(updateStateData({
      [reduxKeywordToSaveValue]: {
        ...currentStateData[reduxKeywordToSaveValue],
        "status": statusValues,
        "store_ids": findStoreIds(independentStoreList)
      },
    }));

    setTimeout(() => {
      setDataLoaded(true);
    }, 1000);
  }, []);

  return dataLoaded ? (
    <StickyTopRowStack direction={"row"} spacing={4}>
      {/* ------- stores filter ----------- */}
      <Box sx={{ width: 220 }}>
        <MultiSelect
          enableFullWidth={true}
          label="Status"
          options={statusValues.map((statusName) => {
            return { value: statusName, label: statusName };
          })}
          defaultVal={selectedStatusName}
          selectionCheck={(option, value) => option.label === value.label}
          onBlurCall={(e) => {
            if (statusSelection.length !== 0 && changesMade === true) {
              dispatchAction(updateStateData({
                [reduxKeywordToSaveValue]: {
                  ...currentStateData[reduxKeywordToSaveValue],
                  "status": statusSelection,
                },
              }));
              setChangesMade(false);
            }
          }}
          onChangeCall={(selectedOption) => {
            let userChoices = [];
            selectedOption.forEach((chosen) => {
              if (chosen.label !== "(All)") {
                userChoices.push(chosen.label);
              } else {
                userChoices.push([...new Set(statusValues)]);
              }
            });
            setStatusSelection(userChoices);
            setSelectedStatusName(selectedOption);
            setChangesMade(true);
          }}
        />
      </Box>
    </StickyTopRowStack>
  ) : (
    <></>
  );
};

export default StatusMonitoringFilter;
